"use client";
import { jsxs as p, jsx as a } from "react/jsx-runtime";
import { COLOR_SEVERITY as m } from "../../common/constants/colorSeverity.js";
import { ICON_SEVERITY as f } from "../../common/constants/iconSeverity.js";
import g from "../icon-button/IconButton.js";
import I from "../icon/Icon.js";
import h from "../link/Link.js";
import { css as n } from "@emotion/react";
import e from "@emotion/styled";
import { useFeId as S } from "../../hooks/useFeId.js";
import { COLORS as t } from "../../tokens/colors/Colors.js";
import { FONT_SIZES as w } from "../../tokens/font-sizes/FontSizes.js";
import { FONT_WEIGHTS as y } from "../../tokens/font-weights/FontWeights.js";
import { SHADOWS as A } from "../../tokens/shadows/Shadows.js";
import { SIZES as O } from "../../tokens/sizes/Sizes.js";
import { SPACINGS as o } from "../../tokens/spacings/Spacings.js";
import { forwardRef as E } from "react";
const c = E(
  ({ children: r, feCloseButton: i, feIcon: $, feLink: l, feSeverity: d, ...b }, x) => {
    const s = S();
    return /* @__PURE__ */ p(
      u,
      {
        ...b,
        "aria-describedby": s,
        "aria-label": "polite",
        "data-comp": "alert",
        feSeverity: d,
        ref: x,
        role: "alert",
        children: [
          /* @__PURE__ */ a(I, { feColor: d && f[d].colorAlias, feIcon: $ }),
          /* @__PURE__ */ p(N, { children: [
            /* @__PURE__ */ a("div", { id: s, children: r }),
            l && /* @__PURE__ */ a(R, { ...l, children: l.children })
          ] }),
          i && /* @__PURE__ */ a(
            g,
            {
              ...i,
              "aria-label": (i == null ? void 0 : i["aria-label"]) ?? "Close",
              as: "button",
              feIcon: "close"
            }
          )
        ]
      }
    );
  }
);
c.displayName = "Alert";
const q = c, u = e.div(
  ({ feSeverity: r }) => n`
		border-radius: ${O.s02};
		box-shadow: ${A.md};
		display: flex;
		font-size: ${w.sm};
		gap: ${o.xs};
		padding: ${o.sm} ${o.xs};

		${!r && n`
			background-color: ${t.gray100};
			border: 1px solid ${t.gray600};
		`}

		${r && n`
			/* stylelint-disable indentation */
			background: linear-gradient(
					${m[r].light},
					${m[r].light}
				),
				linear-gradient(${t.white}, ${t.white});
			/* stylelint-enable indentation */
			border: 1px solid ${m[r].base};
		`}
	`
), N = e.div`
	display: flex;
	flex: auto;
	flex-wrap: wrap;
	gap: ${o.xxs} ${o.md};
	justify-content: space-between;
`, R = e(h)`
	font-weight: ${y.normal};
	margin-inline-end: ${o.xs};
	text-transform: uppercase;
`;
export {
  q as default
};
